/**
 * Created by kz on 28.06.17.
 */
import * as actions from './actions'
import * as getters from './getters'

export default {
  namespaced: true,
  state: {
    all: []
  },
  actions,
  getters,
  mutations: {
    receive (state, companies) {
      state.all = companies
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/companies/index.js